const menuItems = [
  {
    id: 'dashboard',
    icon: 'LayoutDashboard',
    label: 'Dashboard',
    subItems: [
      {
        id: 37,
        label: 'Marketing Dashboard',
        icon: 'ShoppingCart',
        url: '/marketing-dashboard',
      },
      {
        id: 38,
        label: 'Sales Dashboard',
        icon: 'Briefcase',
        url: '/sales-dashboard',
      },
      {
        id: 40,
        label: 'Facility Dashboard',
        icon: 'Building2',
        url: '/facility-dashboard',
      },
      {
        id: 39,
        label: 'Operations Dashboard',
        icon: 'UserCog',
        url: '/operations-dashboard',
      },
      {
        id: 41,
        label: 'HR Dashboard',
        icon: 'Users',
        url: '/hr-dashboard',
      },
    ],
  },
  {
    id: 'marketing',
    icon: 'ShoppingCart',
    label: 'Marketing',
    subItems: [
      {
        id: 'marketing-enquiry',
        label: 'Enquiry',
        icon: 'MessageSquareText',
        subItems: [
          {
            id: 4,
            label: 'Create Enquiry',
            icon: 'UserPlus',
            url: '/create-enquiry',
          },
          {
            id: 5,
            label: 'Enquiry Reports',
            icon: 'FileText',
            url: '/enquiry-reports',
          },
        ],
      },
      {
        id: 8,
        label: 'Agents',
        icon: 'Users',
        url: '/create-agency',
      },
      {
        id: 9,
        label: 'Agency Representatives',
        icon: 'Building2',
        url: '/create-agency-rep',
      },
      {
        id: 3,
        label: 'Sales Representatives',
        icon: 'UserCog',
        url: '/create-sales-rep',
      },
      {
        id: 10,
        label: 'Customer Grp Company',
        icon: 'Boxes',
        url: '/create-customer-group',
      },
    ],
  },
  {
    id: 'sales',
    icon: 'Briefcase',
    label: 'Sales',
    subItems: [
      // {
      //   id: 11,
      //   label: 'Sales Contracts',
      //   icon: 'UserPlus',
      //   url: '/create-sales-contract',
      // },
      {
        id: 12,
        label: 'Sales Contract Reports',
        icon: 'FileText',
        url: '/sales-contract-reports',
      },
      // {
      //   id: 60,
      //   label: 'Create Amendment',
      //   icon: 'MapPin',
      //   url: '/create-amendment',
      // },
      {
        id: 62,
        label: 'Amendment Report',
        icon: 'ClipboardList',
        url: '/amendment-report',
      },
      // {
      //   id: 60,
      //   label: 'Create Contract V2',
      //   icon: 'UserPlus',
      //   url: '/create-contract-v2',
      // },
      // {
      //   id: 60,
      //   label: 'Contract Report V2',
      //   icon: 'UserPlus',
      //   url: '/contract-report-v2',
      // },
    ],
  },
  {
    id: 'operations',
    icon: 'UserCog',
    label: 'Operations',
    subItems: [
      {
        id: 23,
        label: 'Resident Clients',
        icon: 'Users',
        url: '/resident-clients',
      },
      {
        id: 62,
        label: 'Additional Services Report',
        icon: 'BarChart3',
        url: '/additional-services-report',
      },
      {
        id: 17,
        label: 'Chargeable Customization',
        icon: 'Tags',
        url: '/chargeable-customization',
      },
      {
        id: 13,
        label: 'Meeting Room Booking',
        icon: 'CalendarPlus',
        url: '/book-meeting-room',
      },
      // {
      //   id: 16,
      //   label: 'Record OT',
      //   icon: 'CalendarClock',
      //   url: '/record-ot',
      // },
      // {
      //   id: 15,
      //   label: 'Day Passes',
      //   icon: 'Calendar',
      //   url: '/create-day-pass',
      // },
      // {
      //   id: 18,
      //   label: 'Record Stationaries',
      //   icon: 'ClipboardCheck',
      //   url: '/record-stationaries',
      // },
      // {
      //   id: 14,
      //   label: 'Parking',
      //   icon: 'MapPin',
      //   url: '/create-parking',
      // },
      {
        id: 21,
        label: 'Delivery Challan',
        icon: 'PackageCheck',
        url: '/create-delivery-challan',
      },

      {
        id: 53,
        label: 'Client Attendance',
        icon: 'UserCheck',
        url: '/client-attendance',
      },
      {
        id: 56,
        label: 'Opex Payment Workflow',
        icon: 'Workflow',
        url: '/opex-workflow-reports',
      },
      {
        id: 20,
        label: 'Exit Checklist',
        icon: 'ClipboardCheck',
        url: '/create-exit-checklist',
      },
      {
        id: [13, 14, 15],
        label: 'Walk-In',
        icon: 'UserPlus',
        url: '/walk-in',
      },
      {
        id: 43,
        label: 'Meeting Room',
        icon: 'DoorOpen',
        url: '/meeting-room',
      },
      {
        id: 60,
        label: 'Watchman Management',
        icon: 'Shield',
        url: '/watchman-management',
      },
    ],
  },
  {
    id: 'accounts',
    icon: 'HandCoins',
    label: 'Accounts',
    subItems: [
      {
        id: 'Invoices',
        label: 'Invoices',
        icon: 'ScrollText',
        subItems: [
          {
            id: 24,
            label: 'Invoice Schedule',
            icon: 'UserPlus',
            url: '/invoice-schedule',
          },
          {
            id: 25,
            label: 'Invoice Schedule Report',
            icon: 'FileText',
            url: '/invoice-schedule-report',
          },
          {
            id: 45,
            label: 'Client Invoices',
            icon: 'Receipt',
            url: '/client-invoices',
          },
        ],
      },
      {
        id: 'Procurement',
        label: 'Procurement',
        icon: 'CalendarRange',
        subItems: [
          // {
          //   id: 46,
          //   label: 'Purchase Contract',
          //   icon: 'FilePlus',
          //   url: '/purchase-contract',
          // },
          {
            id: 47,
            label: 'Purchase Contract Reports',
            icon: 'BarChart3',
            url: '/purchase-contract-reports',
          },
          // {
          //   id: 48,
          //   label: 'Purchase Contract Schedule',
          //   icon: 'CalendarPlus',
          //   url: '/purchase-contract-schedule',
          // },
          {
            id: 49,
            label: 'Purchase Contract Schedule Reports',
            icon: 'LineChart',
            url: '/purchase-contract-schedule-reports',
          },
        ],
      },
      {
        id: 44,
        label: 'Meeting Room Credits',
        icon: 'Wallet',
        url: '/meeting-room-credits',
      },
      {
        id: 55,
        label: 'Monthly Opex Checklist',
        icon: 'FileText',
        url: '/opex-checklist-reports',
      },
    ],
  },
  {
    id: 'facilities',
    icon: 'Building2',
    label: 'Facilities',
    subItems: [
      {
        id: 26,
        label: 'Vendors',
        icon: 'Users',
        url: '/create-vendor',
      },
      {
        id: 28,
        label: 'Product Type',
        icon: 'Tags',
        url: '/create-product-type',
      },
      {
        id: 27,
        label: 'Equipment',
        icon: 'Shapes',
        url: '/create-equipments',
      },
      {
        id: 29,
        label: 'Maintenance Schedule',
        icon: 'Calendar',
        url: '/maintenance-schedule',
      },
      {
        id: 30,
        label: 'Maintenance Record',
        icon: 'FileText',
        url: '/maintenance-record',
      },
      {
        id: 50,
        label: 'Product',
        icon: 'Package',
        url: '/product',
      },
      {
        id: 54,
        label: 'Project Costing Reports',
        icon: 'ScrollText',
        url: '/project-costing-reports',
      },
    ],
  },
  {
    id: 'hr',
    icon: 'Users',
    label: 'HR',
    subItems: [
      {
        id: 31,
        label: 'Employee',
        icon: 'Users',
        url: '/create-employee',
      },
      {
        id: 32,
        label: 'Employee Details',
        icon: 'FileText',
        url: '/employee-details',
      },
      {
        id: 33,
        label: 'Employee Exit Checklist',
        icon: 'ClipboardCheck',
        url: '/employee-exit-checklist',
      },
      {
        id: 34,
        label: 'Exit Reports',
        icon: 'FileText',
        url: '/employee-exit-checklists-reports',
      },
    ],
  },
  {
    id: 'admin',
    icon: 'Shield',
    label: 'Admin',
    subItems: [
      {
        id: 1,
        label: 'Register User',
        icon: 'UserPlus',
        url: '/register-user',
      },
      {
        id: 42,
        label: 'Update User',
        icon: 'UserCog',
        url: '/update-user',
      },
      {
        id: 51,
        label: 'Vendor Types',
        icon: 'Tag',
        url: '/vendor-types',
      },
      {
        id: 52,
        label: 'Units',
        icon: 'Shapes',
        url: '/units',
      },
      {
        id: 57,
        label: 'Lease Finance Institution',
        icon: 'ScrollText',
        url: '/lease-finance-institution',
      },
    ],
  },
  {
    id: 19,
    label: 'IMS',
    icon: 'MessageCircle',
    url: '/create-ims',
  },
  {
    id: 7,
    label: 'Site Visits',
    icon: 'MapPin',
    url: '/site-visits',
  },
  {
    id: 35,
    label: 'Leave Management',
    icon: 'Calendar',
    url: '/leave-management-v2',
  },
  {
    id: 58,
    label: 'Visitor Management',
    icon: 'UserCheck',
    url: '/visitor-management',
  },
  {
    id: 59,
    label: 'Visitor Management Reports',
    icon: 'FileText',
    url: '/visitor-management-reports',
  },
]

export default menuItems
